export default __webpack_public_path__ + "static/media/logo.944aef5c.svg";